// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_99393d'","fontWeight":700},"className":"__className_99393d","variable":"__variable_99393d"};